import { FC } from "react";

import Skeleton from "../Skeleton/Skeleton";

import styles from "./CardSkeleton.module.css";



const CardSkeleton: FC = () => {
  return (
    <div className={styles.cardSkeleton}>
      <Skeleton height={80} />
    </div>
  );
};

export default CardSkeleton;